import { Icon, SegmentedCard, Typography } from '@smartgift/frontend-toolkit';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { RECOGNITION_CONTACTS_TAB } from '@hero/constants';
import { ReviewSection } from '@hero/molecules';

import ContactIndividualContent from './ContactIndividualContent';
import ContactListContent from './ContactListContent';
import * as S from './style';

export function ContactSection({
  isCompleted = false,
  stepIndex = 2,
  defaultActiveTab = null,
  warnings,
  updateContact,
  recognition
}) {
  const { t } = useTranslation();

  const [tab, setTab] = useState(defaultActiveTab);

  useEffect(() => {
    setTab(defaultActiveTab);
  }, [defaultActiveTab]);

  function handleUpdateContact(data) {
    updateContact({ contacts: { type: tab, ...data.contacts }, ...data });
  }

  const newContactOptions = [
    {
      value: RECOGNITION_CONTACTS_TAB.list,
      title: t('addGiftRecipientsBulkTitle'),
      icon: <Icon name="recipient-email" size="xl" />,
      hiddenInput: false,
      description: t('addGiftRecipientsBulkSubTitle'),
      bottomContent: (
        <S.TabDescriptionText variant="caption1">
          <Icon name="success" />
          <Trans i18nKey="howToSendOption1DescriptionBox" components={{ b: <b /> }} />
        </S.TabDescriptionText>
      ),
      children: (
        <ContactListContent
          updateContact={handleUpdateContact}
          recognitionCode={recognition?.code}
          recipientIds={recognition?.contacts?.ids}
        />
      )
    },
    {
      value: RECOGNITION_CONTACTS_TAB.number,
      title: t('addGiftRecipientsQuantityTitle'),
      icon: <Icon name="recipient-quantity" size="xl" />,
      hiddenInput: false,
      description: t('addGiftRecipientsQuantitySubTitle'),
      bottomContent: (
        <S.TabDescriptionText variant="caption1">
          <Icon name="success" />
          <Trans i18nKey="howToSendOption2DescriptionBox" components={{ b: <b /> }} />
        </S.TabDescriptionText>
      ),
      children: (
        <ContactIndividualContent
          updateContact={handleUpdateContact}
          recognitionCode={recognition?.code}
          recipientQuantity={recognition?.contacts?.maxCount}
          recipientVerification={recognition?.settings?.recipientVerification}
        />
      )
    }
  ];

  return (
    <ReviewSection
      id="section-contact"
      warnings={warnings}
      stepIndex={stepIndex}
      title={t('addGiftRecipients')}
      subTitle={t('addGiftRecipientsDescription')}
      titleHintText={
        recognition?.contacts?.maxCount > 0 && (
          <Typography variant="subtitle3">
            ({`${recognition?.contacts?.maxCount} ${t('recipients').toLocaleLowerCase()}`})
          </Typography>
        )
      }
      isCompleted={isCompleted}
    >
      <S.TabWrapper>
        <SegmentedCard
          updateHash={false}
          options={newContactOptions}
          activeTab={tab}
          onChange={tab => {
            setTab(tab);
            handleUpdateContact({ contacts: { type: tab } });
          }}
          direction="horizontal"
          isLeftAlignedDescription
          error={!!warnings?.length}
        />
      </S.TabWrapper>
    </ReviewSection>
  );
}
